import type { tedsSandboxPageAPIInterface } from "@dealer-center/ddc-pages-teds-sandbox-page-interface";
import { Alert } from "@dealer-center/core-components";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import styled from "styled-components";

const StyledResultsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const StyledResultArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledResultHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const StyledResultPre = styled.pre`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 1rem;
`;

interface PagesTedsSandboxPageUiResultsProps {
  data?: tedsSandboxPageAPIInterface;
  loading: boolean;
  error: Error | null;
}

export const PagesTedsSandboxPageUiResults = ({
  data,
  error,
  loading
}: PagesTedsSandboxPageUiResultsProps) => {
  if (error) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" sx={{ marginBottom: "16px" }} type="error">
          {error.message}
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  if (loading) {
    return (
      <StyledResultsArea>
        <LoadingIndicator
          actionName="Loading Ted's Sandbox Page"
          data-testid="PagesTedsSandboxPageUiLoading"
        />
      </StyledResultsArea>
    );
  }

  if (!data) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" type="info">
          No data
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  return (
    <StyledResultsArea>
      <StyledResultArea>
        <StyledResultHeader>Result</StyledResultHeader>
        <StyledResultPre>{JSON.stringify(data)}</StyledResultPre>
      </StyledResultArea>
    </StyledResultsArea>
  );
};
